/**
 * Variant content updater (price, buttons, etc.) for product pages.
 * Only runs when a product form with variant picker and product JSON is present.
 * Call from inline variant picker scripts after changing the selected variant id.
 */
(function () {
  'use strict';

  function getProductData(form) {
    if (typeof theme === 'undefined' || !theme.OptionManager || !theme.OptionManager.getProductData) {
      return null;
    }
    return theme.OptionManager.getProductData(form);
  }

  function getProductDataFromDom(productId) {
    var el = document.getElementById('ccProductJson-' + productId);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /** Variant prices from Liquid (same source as initial price block) to avoid rounded product JSON. */
  function getVariantPricesFromLiquid(productId) {
    var el = document.getElementById('marlowVariantPrices-' + productId);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * Updates price, buttons, and related UI for the selected variant.
   * Safe to call from variant picker scripts. No-op if not on a product page or data missing.
   * @param {number} variantId - Selected variant id
   */
  function marlowUpdateVariantContent(variantId) {
    if (!variantId) return;

    var $ = window.jQuery || window.$;
    if (!$) return;

    var $idInput = $('#selectedVariantId, #singleVariantId').filter(function () {
      return $(this).closest('.product-container').length > 0;
    }).first();
    if ($idInput.length === 0) {
      $idInput = $('.product-container input[name="id"]').first();
    }
    if ($idInput.length === 0) return;

    var $form = $idInput.closest('form');
    if ($form.length === 0) return;

    var productId = $form.data('product-id');
    if (!productId) return;

    var productData = getProductData($form);
    if (!productData && productId) {
      productData = getProductDataFromDom(productId);
      if (productData && typeof theme !== 'undefined') {
        theme.productData = theme.productData || {};
        theme.productData[productId] = productData;
      }
    }
    if (!productData || !productData.variants) return;

    var variant = null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (Number(productData.variants[i].id) === Number(variantId)) {
        variant = productData.variants[i];
        break;
      }
    }
    if (!variant) return;

    var variantPrices = getVariantPricesFromLiquid(productId);
    if (variantPrices && variantPrices[variantId]) {
      var p = variantPrices[variantId];
      variant = Object.assign({}, variant, {
        price: p.price,
        compare_at_price: p.compare_at_price != null ? p.compare_at_price : variant.compare_at_price
      });
    }

    var $container = $form.closest('.product-container');
    if ($container.length === 0) return;

    if (typeof theme !== 'undefined' && theme.OptionManager) {
      var om = theme.OptionManager;
      if (om.updatePrice) om.updatePrice(variant, $container);
      if (om.updateButtons) om.updateButtons(variant, $container);
      if (om.updateSku) om.updateSku(variant, $container);
      if (om.updateBarcode) om.updateBarcode(variant, $container);
      if (om.updateWeight) om.updateWeight(variant, $container);
      if (om.updateInventoryNotice) om.updateInventoryNotice(variant, $container);
      if (om.updateBackorder) om.updateBackorder(variant, $container);
      if (om.updateContainerStatusClasses) om.updateContainerStatusClasses(variant, $container);
      if (om.updateInventoryLimit) om.updateInventoryLimit(variant, $container);
      if (variant && variant.featured_media) {
        $container.find('.product-gallery').trigger('variantImageSelected', variant);
      }
      $(window).trigger('cc-variant-updated', { variant: variant, product: productData });
      return;
    }

    var $priceArea = $container.find('.product-price');
    if ($priceArea.length && variant) {
      $priceArea.removeClass('on-sale');
      var priceCents = Number(variant.price);
      var compareAtCents = variant.compare_at_price != null ? Number(variant.compare_at_price) : 0;
      var showDiscount = compareAtCents > priceCents;
      var priceHtml = '';
      if (typeof theme !== 'undefined' && theme.formatMoney) {
        priceHtml = '<span class="current-price theme-money">' + theme.formatMoney(variant.price) + '</span>';
        if (showDiscount) {
          priceHtml += ' <span class="was-price theme-money">' + theme.formatMoney(variant.compare_at_price) + '</span>';
          $priceArea.addClass('on-sale');
        }
      } else {
        var formatCents = function (cents) {
          var c = Math.floor(Number(cents));
          var d = Math.floor(c / 100);
          var p = c % 100;
          return d + '.' + String(p < 0 ? p + 100 : p).padStart(2, '0');
        };
        priceHtml = '<span class="current-price theme-money">' + formatCents(variant.price) + '</span>';
        if (showDiscount) {
          priceHtml += ' <span class="was-price theme-money">' + formatCents(variant.compare_at_price) + '</span>';
          $priceArea.addClass('on-sale');
        }
      }
      $priceArea.html(priceHtml);
    }
  }

  window.marlowUpdateVariantContent = marlowUpdateVariantContent;
})();

/**
 * Recharge / Shopify Subscriptions: keep theme qty adjuster intact and sync
 * "Product Quantity" from the selected selling plan (e.g. 3 for quarterly).
 */
(function () {
  'use strict';

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () {
        fn.apply(null, args);
      }, ms);
    };
  }

  function getProductJson(productId) {
    var el = document.getElementById('ccProductJson-' + productId);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /** Selling plan option used by Recharge prepaid qty (name may vary slightly). */
  function getPlanProductQuantity(product, sellingPlanId) {
    if (!product || !product.selling_plan_groups || !sellingPlanId) return null;
    var id = String(sellingPlanId);
    for (var g = 0; g < product.selling_plan_groups.length; g++) {
      var group = product.selling_plan_groups[g];
      if (!group || !group.selling_plans) continue;
      for (var p = 0; p < group.selling_plans.length; p++) {
        var plan = group.selling_plans[p];
        if (String(plan.id) !== id || !plan.options) continue;
        for (var o = 0; o < plan.options.length; o++) {
          var opt = plan.options[o];
          if (!opt || !opt.name) continue;
          if (String(opt.name).toLowerCase().replace(/\s+/g, ' ').trim() !== 'product quantity') continue;
          var n = parseInt(opt.value, 10);
          return isNaN(n) || n < 1 ? null : n;
        }
      }
    }
    return null;
  }

  function getSelectedSellingPlanId($form) {
    var $sel = $form.find('select[name="selling_plan"]');
    if ($sel.length) {
      return $sel.val() || '';
    }
    var $radioChecked = $form.find('input[name="selling_plan"]:checked');
    if ($radioChecked.length) {
      return $radioChecked.val() || '';
    }
    var $hidden = $form.find('input[name="selling_plan"]').filter('[type="hidden"]');
    if ($hidden.length) {
      return $hidden.val() || '';
    }
    var $any = $form.find('input[name="selling_plan"]').first();
    return $any.length ? $any.val() || '' : '';
  }

  /**
   * Recharge v2 widget: radios live inside nested shadow roots. value "" = one-time purchase.
   * Shadow :checked can lag behind the real purchase type; empty selling_plan on the form is authoritative for OTP.
   */
  function getRechargeQuantityUpsellPlanValue(form) {
    var widget = form.querySelector('recharge-subscription-widget');
    if (!widget || !widget.shadowRoot) {
      return undefined;
    }

    function findChecked(root) {
      if (!root || !root.querySelector) return undefined;
      var inp = root.querySelector('input[name="quantityUpsellOption"]:checked');
      if (inp) {
        return inp.value;
      }
      var nodes = root.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].shadowRoot) {
          var v = findChecked(nodes[i].shadowRoot);
          if (v !== undefined) return v;
        }
      }
      return undefined;
    }

    return findChecked(widget.shadowRoot);
  }

  /**
   * One-time if either the cart field is cleared or the widget radio is one-time (value ""), so we
   * are not fooled by: (a) stale :checked in shadow while selling_plan is already "", or (b) hidden
   * field lagging while the widget already shows one-time.
   */
  function getEffectiveSellingPlanId($form) {
    var el = $form[0];
    var fromForm = getSelectedSellingPlanId($form) || '';
    var upsell = el ? getRechargeQuantityUpsellPlanValue(el) : undefined;

    if (upsell !== undefined && upsell === '') {
      return '';
    }
    if (fromForm === '') {
      return '';
    }
    if (upsell !== undefined && upsell !== '') {
      return String(upsell);
    }
    return fromForm;
  }

  /**
   * Recharge prepends/moves line-item quantity to the form root. Theme markup expects
   * it inside .qty-adjuster__inner between − and +. Gather inputs from the whole form.
   */
  function normalizeQtyAdjuster(form) {
    var $ = window.jQuery;
    if (!$ || !form) return;
    var $form = $(form);
    var $adj = $form.find('.payment-and-quantity .qty-adjuster').first();
    if (!$adj.length) return;
    var $inner = $adj.find('.qty-adjuster__inner').first();
    if (!$inner.length) return;

    var $candidates = $form.find('input[name="quantity"]').filter(function () {
      var type = (this.getAttribute('type') || 'text').toLowerCase();
      return type !== 'hidden';
    });

    if (!$candidates.length) {
      return;
    }

    var innerEl = $inner[0];
    var $inside = $candidates.filter(function () {
      return innerEl.contains(this);
    });

    var $primary;
    if ($inside.length) {
      $primary = $inside.first();
      $candidates.not($primary).remove();
    } else {
      $primary = $candidates.first();
      $candidates.not($primary).remove();
    }

    $primary.addClass('qty-adjuster__value');

    if (!innerEl.contains($primary[0])) {
      var $down = $inner.find('.qty-adjuster__down').first();
      if ($down.length) {
        $primary.insertAfter($down);
      } else {
        $inner.prepend($primary);
      }
    }
  }

  function syncSubscriptionQuantity(form) {
    var $ = window.jQuery;
    if (!$ || !form || typeof theme === 'undefined') return;

    var $form = $(form);
    var productId = $form.data('product-id');
    if (!productId) return;

    normalizeQtyAdjuster(form);

    var $qtyInput = $form.find('.payment-and-quantity .qty-adjuster__inner input[name="quantity"]').filter(function () {
      var type = (this.getAttribute('type') || 'text').toLowerCase();
      return type !== 'hidden';
    }).first();

    if (!$qtyInput.length) return;

    var $adj = $qtyInput.closest('.qty-adjuster');

    var product = getProductJson(productId);
    if (product && product.selling_plan_groups && product.selling_plan_groups.length) {
      var sellingPlanId = getEffectiveSellingPlanId($form);
      var qty = getPlanProductQuantity(product, sellingPlanId);

      if (!sellingPlanId) {
        $qtyInput.val('1');
      } else if (qty != null) {
        $qtyInput.val(String(qty));
      }
    }

    if (typeof theme.updateAdjusterButtonsDisabledState === 'function' && $adj.length) {
      theme.updateAdjusterButtonsDisabledState($adj, false);
    }
  }

  function initForm(form) {
    if (!form || form._marlowSubscriptionQtyInit) return;
    form._marlowSubscriptionQtyInit = true;

    var run = debounce(function () {
      syncSubscriptionQuantity(form);
    }, 50);

    syncSubscriptionQuantity(form);

    if (typeof window.MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function () {
        run();
      });
      obs.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value']
      });
    }

    form.addEventListener(
      'change',
      function () {
        run();
      },
      true
    );
  }

  function boot() {
    var $ = window.jQuery;
    if (!$) return;

    $('form[action*="/cart/add"][data-product-id]').each(function () {
      initForm(this);
    });

    $(window).on('cc-variant-updated', function () {
      $('form[action*="/cart/add"][data-product-id]').each(function () {
        syncSubscriptionQuantity(this);
      });
    });

    [100, 400, 1000].forEach(function (ms) {
      setTimeout(function () {
        $('form[action*="/cart/add"][data-product-id]').each(function () {
          syncSubscriptionQuantity(this);
        });
      }, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
